import {
    ServicesPageContainer,
    ServicePageOverlay,
    ServicePageBg,
    ServicePageContent,
    ServicePageTitle,
    ServicePageSecondContent,
    ServicePageSubText,
    ServicesPricingSection,
    ServicePageSubTextBottom
} from "../ServicesElements";
import {
    PricingGrid,
    PricingCard,
    PricingImage,
    PricingBody,
    PricingTitle,
    PricingList,
    PricingFooter,
    PricingFootText,
    PricingButton
} from "../PricingElements";
import {
    DesktopOnly,
    MobileOnly,
    MobileContainer,
    MobileTitle,
    MobileVideo
} from "../../CommonElements";
import { useNavigate } from "react-router-dom";
import firstImage from "../../../images/pricing/sociale1.jpg";
import secondImage from "../../../images/pricing/sociale2.jpg";
import thirdImage from "../../../images/pricing/sociale3.jpg";

const SocialMedia = () => {
    const navigate = useNavigate();
    const plans = [
    {
        img: firstImage,
        title: "Social Starter",
        price: "£399/month",
        features: [
            "2x Reels",
            "4h Filming",
            "Drone Shots",
            "Licensed Music",
            "Premium Editing",
            "Audio Mastering",
            "3 Months Archived"
        ],
        footText: "For brands that want to stand out with professional video and instantly grab attention on social media.",
        cta: "Find Out More",
        link: "/summary?type=social_basic",
    },
    {
        img: secondImage,
        title: "Growth Pro",
        price: "£699/month",
        features: [
            "4x Reels",
            "6h Filming",
            "Drone Shots",
            "Licensed Music",
            "Premium Editing",
            "Audio Mastering",
            "2x Revisions",
            "6 Months Archived"
        ],
        footText: "For brands that want consistent, regular, and professional video content to keep their audience engaged.",
        cta: "Find Out More",
        link: "/summary?type=social_standard",
    },
    {
        img: thirdImage,
        title: "Brand Dominator",
        price: "£1299/month",
        features: [
            "8x Reels",
            "12h Filming (2 days)",
            "3x Revisions",
            "Monthly Report",
            "Cinematic Colour Grade",
            "Dedicated Trend Check",
            "Full Commercial Rights",
            "12 Months Archived",
            "Drone Shots",
            "Licensed Music",
            "Premium Editing",
            "Audio Mastering"
        ],
        footText: "For brands ready to dominate their industry and publish content that attracts, engages, and converts.",
        cta: "Find Out More",
        link: "/summary?type=social_premium",
    },
    ];

    return (
        <>
            <DesktopOnly>
                <ServicesPageContainer>
                    <ServicePageBg>
                        <video autoPlay loop muted playsInline className="App-logo">
                        <source src="/videos/Social_Media_Video_Background.mp4" type="video/mp4" />
                        </video>
                        <ServicePageOverlay />
                    </ServicePageBg>

                    <ServicePageContent>
                        <ServicePageTitle>
                        Social Media videos that grab attention
                        <br />
                        <br />
                        <br />
                        spark engagement, and inspire others
                        <br />
                        </ServicePageTitle>
                    </ServicePageContent>
                </ServicesPageContainer>
            </DesktopOnly>

            <MobileOnly>
                <MobileContainer>
                    <MobileTitle mobileFontSize="18px">
                        Social Media videos that grab attention
                        <br />
                        spark engagement, and inspire others
                    </MobileTitle>
                    <MobileVideo
                    autoPlay
                    muted
                    playsInline
                    loop
                    src="/videos/Social_Media_Video_Background.mp4"
                    />
                </MobileContainer>
            </MobileOnly>

        <ServicePageSecondContent>
            <ServicePageSubText>
                From viral campaigns and brand launches to everyday social stories, we capture every moment with creativity and impact.
                <br />
                <br />
                <br />
                Our social media videos don’t just showcase content — they tell your story, spark engagement, and inspire your audience to act, share, and follow.
                <br />
                <br />
                <br />
                Choose the Plan That Fits You Best
            </ServicePageSubText>
        </ServicePageSecondContent>
        <ServicesPricingSection>
            <PricingGrid>
                {plans.map((p) => (
                    <PricingCard key={p.title}>
                    {p.img && <PricingImage src={p.img} alt={p.title} mobileHeight="260px"/>}
                    <PricingBody>
                        <PricingTitle>{p.title} <span style={{fontSize: '18px'}}>{p.price}</span></PricingTitle>
                        <PricingList>
                        {p.features.map((f) => (
                            <li key={f}>{f}</li>
                        ))}
                        </PricingList>
                    </PricingBody>
                    <PricingFooter>
                        <PricingFootText>{p.footText}</PricingFootText>
                        <PricingButton type="button" aria-label={p.cta} onClick={() => navigate(p.link)}>
                        {p.cta}
                        </PricingButton>
                    </PricingFooter>
                    </PricingCard>
                ))}
            </PricingGrid>
        </ServicesPricingSection>
        <ServicePageSecondContent>
            <ServicePageSubText>
                Didn't find the right package? 
                <br />
                <br />
                <PricingButton type="button" aria-label={"👉 Request a Custom Quote"} onClick={() => navigate("/contact")}>
                    👉 Request a Custom Quote
                </PricingButton>
            </ServicePageSubText>
        </ServicePageSecondContent>
        <ServicePageSecondContent>
            <ServicePageSubTextBottom>
                <b>Show</b> your brand, products and message in a way that resonates
                <br />
                <br />
                <b>Turn</b> your ideas into powerful stories
                <br />
                <br />
                <b>Inspire</b> your audience to follow, share, and take action
                <br />
                <br />
            </ServicePageSubTextBottom>
        </ServicePageSecondContent>
        </>
    )
};

export default SocialMedia;